var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgColon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 90,
    viewBox: "0 0 114 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_13415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 109,
    height: 83
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 108.356,
    height: 82.0647,
    fill: "#111426"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 7.5,
    width: 107.356,
    height: 81.0647,
    stroke: "white",
    strokeOpacity: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_13415)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.025 13.6882C94.8535 21.2032 86.7648 30.0368 86.7648 40.1835C93.6591 40.9378 99.359 43.5974 103.865 48.1707C108.373 52.7411 110.626 58.0324 110.626 64.0472C110.626 70.4364 108.438 75.8226 104.063 80.2087C99.6901 84.592 94.1883 86.785 87.5601 86.785C80.1366 86.785 73.7065 83.9355 68.2727 78.2363C62.8359 72.5372 60.1189 65.6144 60.1189 57.4708C60.1189 33.0428 74.5698 13.9396 103.468 0.161133L111.025 13.6882ZM51.2419 13.6882C34.9374 21.2032 26.7837 30.0368 26.7837 40.1835C33.811 40.9378 39.576 43.5974 44.0845 48.1707C48.593 52.7411 50.8457 58.0324 50.8457 64.0472C50.8457 70.4364 48.6255 75.8226 44.185 80.2087C39.7445 84.592 34.2072 86.785 27.579 86.785C20.1585 86.785 13.7609 83.9355 8.39206 78.2363C3.02326 72.5372 0.338867 65.6144 0.338867 57.4708C0.338867 33.0428 14.7187 13.9396 43.4843 0.161133L51.2419 13.6882Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgColon);
export default __webpack_public_path__ + "static/media/bgColon.bb34eefe27215e5565a61900f1da851f.svg";
export { ForwardRef as ReactComponent };